import { cn } from '@foam/buoy/src/lib/utils';
import { CSSProperties } from 'react';
import { useIsBlankImage } from '~/hooks/useIsBlankImage';

import { BrandItem } from './BrandExperience';

export interface BrandLogoImageProps {
  item: BrandItem;
  className?: string;
  style?: CSSProperties;
}

/**
 * A brand logo that falls back to the brand name when the image has nothing in
 * it. Brandfetch has no asset for some brands and answers with a fully
 * transparent image rather than a 404, which would otherwise render as an empty
 * gap in the row.
 */
export const BrandLogoImage = ({
  item,
  className,
  style,
}: BrandLogoImageProps) => {
  const blankState = useIsBlankImage(item.src);

  if (blankState === 'blank') {
    return (
      <span
        className={cn(
          'px-2 text-center text-sm font-medium text-neutral-600',
          className,
        )}
      >
        {item.alt}
      </span>
    );
  }

  return (
    <img
      src={item.src}
      alt={item.alt}
      className={cn(
        className,
        // Held invisible (not unmounted) while the pixel check runs, so the row
        // keeps its measured width and nothing shifts once it resolves.
        blankState === 'checking' && 'invisible',
      )}
      loading="lazy"
      draggable={false}
      style={style}
    />
  );
};
